'use client';

import { useEffect } from 'react';
import { logError } from './ErrorBoundary';

export default function GlobalErrorHandler() {
  useEffect(() => {
    const handleWindowError = (event: ErrorEvent) => {
      logError(
        event.error instanceof Error ? event.error : new Error(event.message),
        'window.onerror',
        {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        }
      );
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error =
        event.reason instanceof Error
          ? event.reason
          : new Error(String(event.reason ?? 'Unhandled promise rejection'));
      logError(error, 'unhandledrejection');
    };

    window.addEventListener('error', handleWindowError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleWindowError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
